'use client'

// Context bar shown on chat and genesis pages for agent/session selection.
// Rendered as a thin top strip below the TopBar.
export function ContextBar() {
  return null
}
